/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrears-bill': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M316.3 0c-35.4 0-64 28.6-64 64v64H743c35.4 0 64 28.6 64 64v661.3h64c35.4 0 64-28.6 64-64V64c0-35.4-28.6-64-64-64H316.3z"/><path pid="1" d="M707.7 170.7H153c-35.4 0-64 28.6-64 64V960c0 35.4 28.6 64 64 64h554.7c35.4 0 64-28.6 64-64V234.7c0-35.4-28.6-64-64-64zM575.5 646.9c17.6 0 30 13.4 30 29.8s-12.4 28-30 28H448.2v79.7c0 13.9-13.7 25.2-30.6 25.2-16.8 0-28.7-11.3-28.7-25.2v-79.7H287.1c-17.6 0-31.9-11.5-31.9-28 0-16.4 14.3-29.8 31.9-29.8h101.8v-57.7H287.1c-17.6 0-31.9-11.5-31.9-28 0-16.4 14.3-29.8 31.9-29.8h83.6l-93.1-100.7c-8.4-9.2-5-25.6 7.7-36.5 12.6-10.9 29.6-12.3 38-3.1L418.5 496l93.4-104.9c8.4-9.2 25.4-7.8 38 3.1 12.6 10.9 16 27.3 7.7 36.5l-93.1 100.7h109.1c17.6 0 31.9 13.3 31.9 29.8s-14.3 28-31.9 28H448.2v57.7h127.3z"/>'
  }
})
